let css = require('./header.css');
let { cut } = require('../../../helpers/utils');
let UserMenu = require('./user-menu');
let { redirect } = require('../../../signals/utils');

class Header {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [cut(css.redirect)]: this.redirect
            }
        };
    }

    redirect (e) {
        e.stopPropagation();
        let url = e.currentTarget.getAttribute('cat-url');
        this.$context.signal(redirect, { url: url });
    }
}

module.exports = {
    constructor: Header,
    children: [
        {
            name: 'user-menu',
            component: UserMenu,
            watcher: {
                email: ['user', 'email'],
                isManager: ['user', 'isManager'],
                isOpen: ['header', 'ui', 'settings', 'isOpen'],
                utm: ['utm'],
                isBitrix: ['bitrix', 'isBitrix']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/layout/header/index.js